<div class="grid-pager" *ngIf="pageCount > 1">
    <button class="pagination-btn" (click)="previousPage()">
        <img src="../../assets/icons/buttons/pageBack.svg" class="pageIcon" alt="Previous Page">
    </button>
    <span class="pagination-text">{{ currentPage }} of {{ pageCount }}</span>
    <button class="pagination-btn" (click)="nextPage()">
        <img src="../../assets/icons/buttons/pageNext.svg" class="pageIcon" alt="Next Page">
    </button>
</div>